// PandaDoc document statuses, and what this app is allowed to do with each one.
//
// The embedded editor opens DRAFTS ONLY. PandaDoc still happily mints an
// editing-session token for a document that was already sent, so routing a sent
// doc into the editor mounts the iframe and then dies with an empty
// `document.loading.error` payload — the "PandaDoc could not load this document.
// {}" screen. Decide by status BEFORE mounting the editor.
//
// The API returns statuses as `document.viewed`; some list endpoints return the
// display form ("Viewed"). Normalize both.

const strip = (s?: string | null): string =>
  String(s ?? '').trim().replace(/^document\./i, '').toLowerCase();

/** Editable in the embedded editor. */
export function isDraft(status?: string | null): boolean {
  return strip(status) === 'draft';
}

/** An uploaded file PandaDoc is still converting — becomes `draft` shortly. */
export function isProcessing(status?: string | null): boolean {
  return strip(status) === 'uploaded';
}

/** Sent but unsigned — can be pulled back into draft ("Edit"). The backend
 *  also refuses once any signer has signed; the list doesn't know that. */
export function canRevertToDraft(status?: string | null): boolean {
  const s = strip(status);
  return s === 'sent' || s === 'viewed';
}

/** Fully signed — the signed PDF can be downloaded. */
export function isCompleted(status?: string | null): boolean {
  return strip(status) === 'completed';
}

/** "waiting_approval" → "Waiting approval" */
export function statusLabel(status?: string | null): string {
  const s = strip(status).replace(/_/g, ' ');
  return s ? s.charAt(0).toUpperCase() + s.slice(1) : 'Unknown';
}

/** The document's page in the PandaDoc web app (staff have PandaDoc seats). */
export function pandaDocUrl(documentId: string): string {
  return `https://app.pandadoc.com/a/#/documents/${documentId}`;
}
